var _rect, _rect2, _polyline, _rect3, _rect4, _polyline2, _rect5, _rect6, _polyline3, _rect7, _rect8, _path, _path2, _path3, _rect9, _path4, _ellipse, _path5, _path6, _polygon, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _polygon2, _rect0, _path18, _circle, _circle2, _polyline4, _circle3, _circle4, _polyline5, _circle5, _circle6, _circle7, _line, _line2, _line3, _rect1, _rect10, _rect11, _rect12, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 236.78,
    y: 47.25,
    width: 75.95,
    height: 82.7,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 248.47,
    y: 57.54,
    width: 13.21,
    height: 13.21,
    fill: "#a8a8a8"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "252.31 64.28 254.19 67.12 257.62 62.02",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 268.86,
    y: 61.87,
    width: 30.6,
    height: 5.25,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 248.47,
    y: 81.56,
    width: 13.21,
    height: 13.21,
    fill: "#a8a8a8"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "252.31 88.3 254.19 91.14 257.62 86.04",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 268.86,
    y: 85.89,
    width: 30.6,
    height: 5.25,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 248.47,
    y: 104,
    width: 13.21,
    height: 13.21,
    fill: "#a8a8a8"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "252.31 110.73 254.19 113.58 257.62 108.47",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 268.86,
    y: 108.32,
    width: 30.6,
    height: 5.25,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 236.78,
    y: 175.85,
    width: 75.95,
    height: 51.63,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.78,88.16s27.29,19,27.88,41.78H248.47Z",
    opacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.08,89.73l-24.8,19.72s-23.26,23.33-8.66,38.6S195.49,141,195.49,141Z",
    fill: "#68e1fd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.08,89.73l-24.8,19.72s-23.26,23.33-8.66,38.6S195.49,141,195.49,141Z",
    opacity: 0.08
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 169.08,
    y: 95.86,
    width: 2.86,
    height: 18.51,
    transform: "translate(-28.5 127.81) rotate(-38.16)",
    fill: "#24285b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.28,109.45s3.86-4.56,7.33-3.06,2.55,8.4-3.49,8.52S168.28,109.45,168.28,109.45Z",
    fill: "#f4a28c"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.08,
    cy: 252.84,
    rx: 13.28,
    ry: 75.54,
    transform: "translate(-71.52 433.86) rotate(-89.76)",
    fill: "#e6e6e6",
    opacity: 0.45
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.39,247.09s-1.55,2.93-4.38,2.77-4,2.46-1.54,3.53,9.35-1.22,9.35-1.22l.51-5.16Z",
    fill: "#68e1fd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M204.76,59.18s-.53,5.89.45,9.81a3,3,0,0,0,3.62,2.15A6.56,6.56,0,0,0,214,66.21l1.78-5.16a5.3,5.3,0,0,0-2.32-5.67C210.1,53,204.9,55.58,204.76,59.18Z",
    fill: "#f4a28c"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "215.43 61.99 218.43 81.13 207.76 82.03 209.87 67.74 215.43 61.99",
    fill: "#f4a28c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M211,64.26s.05-2.28,1.76-2.1,1.66,3.47-.67,3.77Z",
    fill: "#f4a28c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M204.62,62.91,203,65.18a1,1,0,0,0,.59,1.49l2.26.43Z",
    fill: "#f4a28c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.27,70.85a7,7,0,0,0,3.47-2.06s-.16,3.55-4.06,7Z",
    fill: "#ce8172",
    opacity: 0.31
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M220,81.14l-13.28,1.12S180.42,90,181.48,114.74s3.45,55.05,3.45,55.05l35.4,4.63S279.19,94.32,220,81.14Z",
    fill: "#68e1fd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M225.61,97S213.1,103.17,214,118.21s-1.61,20.44-17.13,18.7-13.88,5-13.88,5l2,27.87,35.4,4.63,3.19-4.63S251.9,117.89,225.61,97Z",
    opacity: 0.08
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184.93,169.79l-9.51,7.91a20.59,20.59,0,0,0,3.07,33.76l18.23,10.27,6.06-4.41L189.14,206a7.22,7.22,0,0,1,.79-11.68l4.86-3a22,22,0,0,1,8.89-3.19c5.26-.67,14-3.35,16.65-13.68Z",
    fill: "#24285b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M204.62,51.6s-3.35,8.19,3.14,8.85,2.39,5.11,6.21,5.76,8.19-8.63,4.46-13.28S206.48,47.84,204.62,51.6Z",
    fill: "#24285b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M220.33,174.42l-24,72.59-6-.06s8.19-48.44,7.3-68.79Z",
    fill: "#24285b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M221.34,101.84a9.78,9.78,0,0,1,16.47-8.21c6.87,6.48,14.13,16.92,16,32.86,3.86,32.29-7.5,64.05-57.47,12.74l5.08-5.89s24.83,17.15,32.18,14.21C239.24,145.31,223.6,122.1,221.34,101.84Z",
    fill: "#68e1fd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M221.34,101.84a9.78,9.78,0,0,1,16.47-8.21c6.87,6.48,14.13,16.92,16,32.86,3.86,32.29-7.5,64.05-57.47,12.74l5.08-5.89s24.83,17.15,32.18,14.21C239.24,145.31,223.6,122.1,221.34,101.84Z",
    fill: "#fff",
    opacity: 0.46
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M152.32,242.19s8.65-2.33,10.56-10.36c0,0-13.37-2.76-13.81,11Z",
    fill: "#68e1fd",
    opacity: 0.58
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M151.27,241.33s6.07-9.52.8-18.46c0,0-10.21,6.42-5.74,18.46Z",
    fill: "#68e1fd",
    opacity: 0.73
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M149.71,241.33s-3.15-10.09-12.78-12c0,0-1.83,6.53,6.19,12Z",
    fill: "#68e1fd"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "155.97 241.13 154.18 253.1 143.15 253.1 141.57 241.13 155.97 241.13",
    fill: "#24285b"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 170.59,
    y: 110.14,
    width: 26.52,
    height: 38.71,
    transform: "translate(-14.8 24.1) rotate(-7.21)",
    fill: "#ffd200"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M197.69,137.71s-10.28-5-7.78-8.7,11.55,4.33,11.55,4.33Z",
    fill: "#f4a28c"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.73,
    cy: 70.87,
    r: 20.07,
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.73,
    cy: 70.87,
    r: 14.19,
    fill: "#fff"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "120.73 62.72 120.73 72.25 128.55 71.13",
    fill: "none",
    stroke: "#c1c1c1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.73,
    cy: 125.22,
    r: 20.07,
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.73,
    cy: 125.22,
    r: 14.19,
    fill: "#fff"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "120.73 117.07 120.73 126.6 128.55 125.47",
    fill: "none",
    stroke: "#c1c1c1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.89,
    cy: 187.45,
    r: 3.17,
    opacity: 0.08
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.89,
    cy: 201.09,
    r: 3.17,
    opacity: 0.08
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.89,
    cy: 214.73,
    r: 3.17,
    opacity: 0.08
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 258.61,
    y1: 187.45,
    x2: 296.07,
    y2: 187.45,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 258.61,
    y1: 201.09,
    x2: 296.07,
    y2: 201.09,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 258.61,
    y1: 214.73,
    x2: 296.07,
    y2: 214.73,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 102.85,
    y: 172.58,
    width: 35.75,
    height: 28.29,
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 102.85,
    y: 167.26,
    width: 35.75,
    height: 9.35,
    fill: "#c1c1c1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 108.09,
    y: 162.4,
    width: 3.05,
    height: 7.75,
    fill: "#e6e6e6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 130.21,
    y: 162.32,
    width: 3.05,
    height: 7.75,
    fill: "#e6e6e6"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(111.6 194.08)",
    fontSize: 15.5,
    fill: "#fff",
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, "30")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodo);
export default __webpack_public_path__ + "static/media/todo.ae65ee7e99166b967521e1b639feb934.svg";
export { ForwardRef as ReactComponent };